import { type PluginListenerHandle } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { useEffect, useState } from "react";

import { isCapacitorPlatform } from "./platformUtils";

export interface UseIsKeyboardOpenProps {
  keyboardOpenEvent?: "keyboardDidShow" | "keyboardWillShow";
}

export function useIsKeyboardOpen(props: UseIsKeyboardOpenProps = {}) {
  const { keyboardOpenEvent = "keyboardDidShow" } = props;

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (isCapacitorPlatform()) {
      // Passing keyboardOpenEvent to the listener throws type errors,
      // overcoming it with this ugly workaround
      const keyboardOpenEventListener: Promise<PluginListenerHandle> =
        keyboardOpenEvent === "keyboardWillShow"
          ? Keyboard.addListener("keyboardWillShow", () => {
              setIsKeyboardOpen(true);
            })
          : Keyboard.addListener("keyboardDidShow", () => {
              setIsKeyboardOpen(true);
            });

      const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
        setIsKeyboardOpen(false);
      });

      return () => {
        keyboardOpenEventListener
          .then(async (listenerHandle) => {
            await listenerHandle.remove();
          })
          .catch(() => {
            // Ignore errors
          });
        keyboardDidHideListener
          .then(async (listenerHandle) => {
            await listenerHandle.remove();
          })
          .catch(() => {
            // Ignore errors
          });
      };
    }

    return undefined;
  }, [keyboardOpenEvent]);

  return isKeyboardOpen;
}
